import { mString } from 'lib/helpers/utility';

import DrAvatar from './lib/components/DrAvatar';
import InfoCallout from './lib/components/InfoCallout';
import SlideHeader from './lib/components/SlideHeader';
import SpeechBubble from './lib/components/SpeechBubble';

const DentalTotalPage = ({ estimate }) => {
  const { providerCharges = 0, insurancePays = 0, patientResponsibility = 0 } = estimate ?? {};

  const rows = [
    { label: 'Total provider charges', value: mString(providerCharges) },
    { label: 'Estimated insurance payment', value: `−${mString(insurancePays)}`, muted: true },
    { label: 'Your estimated portion', value: mString(patientResponsibility) }
  ];

  return (
    <div className="flex flex-col gap-5">
      <SlideHeader title="Your balance" />

      <SpeechBubble variant="default">
        Here's how your estimated balance of {mString(patientResponsibility)} adds up:
      </SpeechBubble>

      <div className="overflow-hidden rounded-xl border border-solid border-neutral-200 shadow-sm">
        <div className="flex flex-col divide-y divide-neutral-50">
          {rows.map((row) => (
            <div key={row.label} className="flex items-center justify-between px-4 py-2.5">
              <span className="text-sm text-neutral-600">{row.label}</span>
              <span
                className={`text-sm font-500 ${row.muted ? 'text-neutral-400' : 'text-primary-900'}`}>
                {row.value}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-[#0093C4] to-[#00B8E8] p-6 text-center text-white">
        <p className="mb-2 text-sm font-500 opacity-80">Your estimated total for today is</p>
        <p className="text-4xl font-800">{mString(patientResponsibility)}</p>
        <p className="mt-1 text-sm opacity-60">after your insurance pays its share</p>
        <DrAvatar variant={5} size="medium" className="absolute -bottom-4 -right-4 opacity-30" />
      </div>

      <InfoCallout />
    </div>
  );
};

export default DentalTotalPage;
